import styled from 'styled-components';

/** Shared inline-form controls for the Translation Memory collection UI. */

export const TextInput = styled.input`
  width: 100%;
  height: var(--btn-h-sm);
  padding: 0 10px;
  background: var(--background);
  border: 1px solid var(--border);
  border-radius: var(--radius-input);
  color: var(--foreground);
  font-size: var(--text-sm);

  &:focus {
    outline: none;
    border-color: var(--primary);
  }
`;

export const PrimaryButton = styled.button`
  height: var(--btn-h-sm);
  padding: 0 var(--btn-px-sm);
  background: var(--primary);
  color: var(--background);
  border: none;
  border-radius: var(--radius-input);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semi-bold);
  cursor: pointer;

  &:hover:not(:disabled) {
    background: var(--primary-hover);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const GhostButton = styled.button`
  height: var(--btn-h-sm);
  padding: 0 var(--btn-px-sm);
  background: transparent;
  color: var(--foreground);
  border: 1px solid var(--border);
  border-radius: var(--radius-input);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  cursor: pointer;

  &:hover:not(:disabled) {
    background: var(--surface-elevated);
    border-color: var(--text-muted);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

/** Destructive variant for the delete confirmation. */
export const DangerButton = styled(PrimaryButton)`
  background: var(--destructive);

  &:hover:not(:disabled) {
    background: var(--destructive);
    filter: brightness(1.1);
  }
`;

/** Outline destructive variant — red border/text, filling on hover. Used for
 *  the bulk "Delete N" trigger; the solid DangerButton stays for the final
 *  confirmation. */
export const DangerOutlineButton = styled(GhostButton)`
  color: var(--destructive);
  border-color: var(--destructive);

  &:hover:not(:disabled) {
    background: var(--destructive);
    border-color: var(--destructive);
    color: var(--background);
  }
`;

export const Select = styled.select`
  width: 100%;
  height: var(--btn-h-sm);
  padding: 0 30px 0 10px;
  background: var(--background);
  border: 1px solid var(--border);
  border-radius: var(--radius-input);
  color: var(--foreground);
  font-size: var(--text-sm);
  cursor: pointer;

  /* Strip the native chrome so the CSS border matches the text inputs exactly,
     then draw our own chevron. */
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12' fill='none' stroke='%23888888' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M3 4.5 6 7.5 9 4.5'/></svg>");
  background-repeat: no-repeat;
  background-position: right 10px center;

  &:focus {
    outline: none;
    border-color: var(--primary);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  /* Dark the option popup where the browser honors it (Chrome/Windows/Linux,
     Firefox). macOS renders a native menu and may ignore this. */
  option {
    background: var(--surface);
    color: var(--foreground);
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
